import { render, staticRenderFns } from "./ListPermissionCategorie.vue?vue&type=template&id=799cb0b8&scoped=true"
import script from "./ListPermissionCategorie.vue?vue&type=script&lang=js"
export * from "./ListPermissionCategorie.vue?vue&type=script&lang=js"
import style0 from "./ListPermissionCategorie.vue?vue&type=style&index=0&id=799cb0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799cb0b8",
  null
  
)

export default component.exports